import React from 'react';

export function Policies() {
  return <div>Policies.Container</div>;
}
